import type { IPagamentoLoja } from "interfaces/loja";
import { formatCurrency } from "helpers/utils";
import { calcularResumoValoresPedido } from "./pedidoValoresUi";

/**
 * Indicador visual para pedido cancelado (somente UI; inferência a partir dos pagamentos atuais).
 */
export type EstornoPedidoCanceladoUi = "realizado" | "pendente" | "nao_aplicavel";

export function resolveEstornoPedidoCanceladoUi(
  pagamentos: IPagamentoLoja[] | undefined
): EstornoPedidoCanceladoUi {
  const pags = pagamentos ?? [];
  if (
    pags.some(
      (p) => p.status === "PAGO" || p.status === "AUTORIZADO"
    )
  ) {
    return "pendente";
  }
  if (pags.some((p) => p.status === "ESTORNADO")) {
    return "realizado";
  }
  return "nao_aplicavel";
}

/** Alerta quando o valor cobrado inclui juros de parcelamento (estorno na operadora). */
export function textoAlertaEstornoComJuros(
  valorPedido: number | string,
  pagamentos?: IPagamentoLoja[],
): string | null {
  const resumo = calcularResumoValoresPedido(valorPedido, pagamentos);
  if (!resumo.temJuros) return null;

  const relevante = (pagamentos ?? []).some(
    (p) =>
      p.status === "PAGO" ||
      p.status === "AUTORIZADO" ||
      p.status === "ESTORNADO",
  );
  if (!relevante) return null;

  return `O valor cobrado (${formatCurrency(resumo.valorCobrado)}) inclui ${formatCurrency(resumo.valorJuros)} de juros de parcelamento. O estorno na operadora tende a devolver o total cobrado, não apenas o valor comercial do pedido (${formatCurrency(resumo.valorPedido)}).`;
}

export function subtextoEstornoPedidoCancelado(
  ui: EstornoPedidoCanceladoUi,
  valorPedido: number | string,
  pagamentos?: IPagamentoLoja[],
): string | null {
  if (ui === "pendente") {
    const alertaJuros = textoAlertaEstornoComJuros(valorPedido, pagamentos);
    const base =
      "Há pagamento confirmado ou autorizado — conclua o estorno nas linhas de pagamento abaixo.";
    return alertaJuros ? `${base} ${alertaJuros}` : base;
  }
  if (ui === "realizado") {
    return textoAlertaEstornoComJuros(valorPedido, pagamentos);
  }
  return null;
}
